'use client'

import { type ComponentPropsWithRef, type MouseEvent, type ReactNode } from 'react'

import { type AnalyticsEventType } from '@/defs/analytics'
import { type DistributiveOmit, type UtmType } from '@/defs/misc'
import { trackEvent } from '@/utils/analyticsUtil'
import { getUtmLink } from '@/utils/commonUtil'

type LinkOutboundProps = {
  analyticsEvent?: AnalyticsEventType
  children: ReactNode
  href: string
  newTab?: boolean
  onClick?: (e: MouseEvent<HTMLAnchorElement>) => void
  utm?: UtmType | false
}

type Props = LinkOutboundProps & DistributiveOmit<ComponentPropsWithRef<'a'>, keyof LinkOutboundProps>

export const LinkOutbound = ({
  analyticsEvent,
  children,
  href: hrefProp,
  newTab = true,
  onClick: onClickProp,
  utm,
  ...props
}: Props) => {
  const href = utm === false ? hrefProp : getUtmLink(hrefProp, utm)

  const onClick = (e: MouseEvent<HTMLAnchorElement>) => {
    onClickProp?.(e)
    if (e.defaultPrevented) return
    if (analyticsEvent) trackEvent({ ...analyticsEvent, label: analyticsEvent.label || href })
  }

  return (
    <a
      href={href}
      onClick={onClick}
      rel={newTab ? 'noopener noreferrer' : undefined}
      target={newTab ? '_blank' : undefined}
      {...props}
    >
      {children}
    </a>
  )
}
